.fineprint {
    font-size: 12px;
    text-align: center;
}

// OneTrust Button requires the use of !important to override vendor styles
.footer a,
.link,
.oneTrustButton button {
    background-color: transparent !important;
    border: none !important;
    color: var(--blue) !important;
    cursor: pointer !important;
    font-size: 1em !important;
    padding: 0 0.25rem !important;
    text-decoration: underline !important;
}
